<template lang="pug">
    .article-section
        .article-section__text-wrp(:class="[content.position, content.modifiers]")
            .article-section__text(v-html="content.text.join('')")
            .article-section__text-with-image(v-if="content.textAndImage" :class="content.textAndImage.modifier")
                .article-section__text(v-html="content.textAndImage.text.join('')")
                .article-section__image(:class="content.textAndImage.modifier")
                    img(:src="require(`@/assets/img/articles/${id}/illustrations/${content.textAndImage.image}`)")



        .article-section__illust(v-if="content.illustrations" :class="[`article-section__illust_${content.illustrations.id}`, content.illMobPos]")
            Illustration(:content="content.illustrations" :id="id")
</template>

<script>
export default {
    name: 'Section',
    props: {
        content: Object,
        id: String
    },
    components: {
        Strap: () => import('@/components/Strap'),
        Illustration: () => import('@/components/Article/Illustration')
    }
};
</script>

<style lang="scss">
@import '@/assets/css/vars.scss';
.article-section {
    width: 100%;
    max-width: var(--max-width);
    margin: 0 auto;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;

    @media (--viewport-tablet) {
        width: 100%;
        flex-direction: column;
        justify-content: stretch;
        align-items: flex-start;
    }

    &__text-wrp {
        // font-size: 1rem;

        position: relative;
        padding: 70px 0;
        z-index: 1;
        line-height: 1.6;

        @media (--viewport-laptop) {
            padding: 0.5em var(--padding-mobile);
            line-height: 1.4;
        }
        p:not(:last-child) {
            margin-bottom: 1em;
        }
        a {
            text-decoration: none;
            color: var(--color-red);
            &:hover {
                text-decoration: underline;
            }
        }
        &.pb-small-mob {
            padding-bottom: 0.5em;
        }
        &.pt-small-mob {
            padding-top: 0.5em;
        }

        &.left {
            padding-left: calc(var(--padding) * 2);
            width: 50%;
            @media (--viewport-laptop-l) {
                padding-left: calc(var(--padding-mobile) * 2);
            }

            @media (--viewport-laptop) {
                padding-left: var(--padding-mobile);
            }

            @media (--viewport-tablet) {
                width: 100%;
                padding-left: calc(1.5 * var(--padding-mobile));
                padding-right: calc(1.5 * var(--padding-mobile));
            }
        }
        &.right {
            padding-right: calc(var(--padding) * 2);
            order: 3;
            width: 50%;
            @media (--viewport-laptop-l) {
                padding-right: calc(var(--padding-mobile) * 2);
            }

            @media (--viewport-laptop) {
                padding-right: var(--padding-mobile);
            }

            @media (--viewport-tablet) {
                width: 100%;
                padding-left: calc(1.5 * var(--padding-mobile));
                padding-right: calc(1.5 * var(--padding-mobile));
            }
        }
        &.center {
            margin: 0 auto;
            width: 67%;

            @media (--viewport-laptop) {
                width: 80%;
            }
            @media (--viewport-tablet) {
                width: 100%;
                padding-left: calc(1.5 * var(--padding-mobile));
                padding-right: calc(1.5 * var(--padding-mobile));
            }
        }

        &.as-start {
            align-self: flex-start;
        }
    }
    &__illust {
        width: 50%;
        align-self: stretch;
        position: relative;
        z-index: 0;
        @media (--viewport-tablet) {
            width: 100%;
            padding-top: calc(var(--padding-mobile) * 1);
            padding-bottom: calc(var(--padding-mobile) * 1);
        }
        &.mob-bottom {
            @media (--viewport-tablet) {
                order: 3;
            }
        }
        &.mob-top {
            @media (--viewport-tablet) {
                order: -1;
            }
        }
        &_plotkin-ill-2 {
            @media (--viewport-tablet) {
                order: 5;
            }
        }
    }

    &__text-with-image {
        position: relative;
        padding-top: 1em;
        .ohlopkov-ill-2 {
            @media (--viewport-mobile-l) {
                padding-right: 0;
            }
        }
    }

    &__image {
        &.ohlopkov-ill-2 {
            position: absolute;
            top: 50%;
            right: calc(var(--padding) * -2);
            transform: translateY(-50%);
            width: 75%;
            @media (--viewport-laptop-l) {
                right: calc(var(--padding-mobile) * -2);
            }
            @media (--viewport-tablet) {
                position: static;
                width: auto;
                transform: none;
                margin: 0 -10% 0 -20%;
            }
            @media (--viewport-mobile-l) {
                width: 148%;
                margin-left: -35%;
                margin-bottom: -12%;
            }
        }
    }
}

.article-section {
    &__illust {
        &_plotkin {
            &-ill {
                @media (--viewport-tablet) {
                    &-8 {
                        display: none;
                    }

                    &-17 {
                        display: none;
                    }

                    &-20 {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>
